// extracted by mini-css-extract-plugin
module.exports = {"header":"LoginHeader_header__2xKj4","headerTitle":"LoginHeader_headerTitle__2aAzd","headerIcon":"LoginHeader_headerIcon__2uAZS"};